/* eslint-disable */
import React, { Component } from 'react'
// import PropTypes from 'prop-types';
import { Text, View, TouchableHighlight, Image, ImageEditor, ImageStore
        , TextInput, Keyboard, Animated, ScrollView, Dimensions, TouchableOpacity, StyleSheet, Platform } from 'react-native'
import styles from './Styles/PostLinkComponentStyle'
import { Images, Fonts } from '../Themes'
import { Input } from 'native-base'
//import RNFetchBlob from 'react-native-fetch-blob'
import { connect } from 'react-redux'
import API from '../Services/Api'
import FixtureAPI from '../Services/FixtureApi'
import DebugConfig from '../Config/DebugConfig'
import LottieView from 'lottie-react-native'
import DeviceInfo from 'react-native-device-info'
import I18n from "i18n-js"
import {launchImageLibrary} from 'react-native-image-picker';

// import { decode } from 'html-entities'
const Entities = require('html-entities').AllHtmlEntities;
const entities = new Entities();

import PostsActions from "../Redux/PostsRedux"
import {WebView} from 'react-native-webview'
import { closestKargoeRatio, alertView } from '../Lib/utils'

import customMainNavBarStyles from "../Components/Styles/CustomMainNavBarStyle" // for status bar
const customMainNavBarStylesContent = StyleSheet.flatten(customMainNavBarStyles.content)
const customMainNavBarStylesStatusBar = StyleSheet.flatten(customMainNavBarStyles.statusBar)
const statusAndNavHeight = customMainNavBarStylesContent.height + customMainNavBarStylesStatusBar.height

const linkPostExpandedHeight = 278
const thumbWidthRatio = 0.3 // 0.315
const DefaultImage = 'https://s3.amazonaws.com/kargoe-docs/meta-picture-01.jpg'

const LIBRARY_INDEX = 9999 // for user-selected image from his own photo library

// 'about:blank' is causing trouble in 0.60.5 react native so i put in a small data url instead
const aboutBlank = '' // 'https://google.com' 

let { width : origScreenWidth, height : screenHeight } = Dimensions.get('window')
class PostLinkComponent extends Component {
  constructor(props) {
    super(props)

    let factor = window.mainViewWidthFraction ? window.mainViewWidthFraction : 1
    screenWidth = origScreenWidth * factor

    // this.userAgent = 'unknown'
    // DeviceInfo.getUserAgent().then(userAgent => { this.userAgent = userAgent })
    // this.userAgent = 'Mozilla/5.0 (iPhone; CPU iPhone OS 12_2 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Mobile/15E148' // problems with google.com/amp mobile
    this.userAgent = 'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_14_5) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/12.1.1 Safari/605.1.15'
    this.results = { }
    this.filtered = { }
    // this.scanTimes = [ 1000, 2000, 5000, 10000, 22000, 30000, 60000 ] // [ 1000, 2000, 5000, 10000, 22000, 30000, 60000 ] orig.  now with ready delay of 2s
    this.state = {
      fetching: false,
      wantScan: false,
      selectedImageIndex: 0,
      scanText: '',
      url: aboutBlank,
      fetched: aboutBlank,
      images: [ ],
      hasScrolled: false,
      showSpinner: false,
      filteredCount: 0,
      refresh: 0,
      renderBump: 0,
      hidePostButton: false,
      creatingPost: false,
    }
    this.typing = Date.now( )
    this.realText = ''
    this.realNavUrl = ''
    this.api = DebugConfig.useFixtures ? FixtureAPI : API.create( )
    this.dropdown = new Animated.Value(45)
    this.siteMetaFetchCode = siteMetaFetch.toString()
    this.siteMetaFetchFuncName = this.getNameFromFuncDef(this.siteMetaFetchCode)
    this.siteImageFetchCode = siteImageFetch.toString()
    this.siteImageFetchFuncName = this.getNameFromFuncDef(this.siteImageFetchCode)
    this.filterResults = this.filterResults.bind(this)
    this.onScanSite = this.onScanSite.bind(this)
    this.makePostLink = this.makePostLink.bind(this)
    this.periodic = this.periodic.bind(this)
    this.parseHTMLForMeta = this.parseHTMLForMeta.bind(this)
    this.postlinkinput = null
    this.textview = null
    this.webview = null
    //this.refs = {textview: null, webview: null}
    // console.tron.log(`PostLinkComponent construct siteFetchFuncName: ` + this.siteFetchFuncName)
    this.intervalUpdater = null
    console.tron.log(`PostLinkComponent constructor user agent: ${this.userAgent}`)
  }

  getNameFromFuncDef(funcDef) {
  	var temp = funcDef.replace('function', '').trim();
  	var endIndex = temp.indexOf('(');
  	return temp.substr(0, endIndex);
  }
  
  periodic() {
    if (this.state.url != aboutBlank && this.state.url != '') {
      const siteDetails = this.results[this.state.url] ? this.results[this.state.url] : null
      const newState =  siteDetails && (Date.now() - siteDetails.startTime) < 60000 && this.filtered[this.state.url].length < 3
      if (this.state.showSpinner != newState)
        this.setState({showSpinner: newState})
    }
  }

  componentWillMount ( ) {
    this.subs = [
      this.props.nav.addListener( 'didFocus', ( ) => {this.setState({ focused : true })} )
    , this.props.nav.addListener( 'willBlur', ( ) => {
        this.setState({ focused : false })
        console.log('clearing link post background timers')
        if( this.navStateChange ) {
          this.navStateChange.forEach(clearTimeout)
          this.navStateChange = false
          this.fetched = aboutBlank
        }
      })
    ]
    this.intervalUpdater = setInterval(this.periodic, 500) // 2000 // every few seconds update so we can get rid of spinny loader
  }

  componentWillUnmount( ) {
    this.subs.forEach(sub => sub.remove( ))
    clearInterval(this.intervalUpdater)
  }

  componentDidMount( ) { this.api.setAuthorization(this.props.auth.token) }
  
  partOfHtml(html, tagStart, tagEnd) {
    const tagStartPos = html.indexOf(tagStart)
    const tagEndPos   = html.indexOf(tagEnd, tagStartPos > 0 ? tagStartPos + tagStart.length + 1 : 0)
    const content     = tagStartPos > 0 && tagEndPos > 0 ? html.substr(tagStartPos + tagStart.length, tagEndPos - tagStartPos - tagStart.length) : ' '
    const decodedContent = entities.decode(content) // decodeURIComponent, decodeURI
    console.log("parseHTMLForMeta partOfHtml", tagStart, tagEnd, tagStartPos, tagEndPos, content) // , decodedContent)
    console.log("parseHTMLForMeta decodedContent done")
    return decodedContent
  }

  partOfHtmlBackwards(html, tagStart, tagEnd) {
		const tagEndPos   = html.indexOf(tagEnd)
    const tagStartPos = html.substr(0, tagEndPos).lastIndexOf(tagStart)
    const content     = tagStartPos > 0 && tagEndPos > 0 ? html.substr(tagStartPos + tagStart.length, tagEndPos - tagStartPos - tagStart.length) : ' '
    const decodedContent = entities.decode(content) // decodeURIComponent, decodeURI
    console.log("parseHTMLForMeta partOfHtmlBackwards", tagStart, tagEnd, tagStartPos, tagEndPos, content, decodedContent)
    return decodedContent
  }

	tagContent(html, tag) {
    const tagStart = `<${tag}>`
		const tagEnd   = `</${tag}>`
		return this.partOfHtml(html, tagStart, tagEnd)
  }

  getYouTubeId = (url) => {
    const isYouTubeShortcut = url.indexOf("//youtu.be/") > 0
    const isYouTube   = url.indexOf("//www.youtube.com/watch") > 0 || url.indexOf("//m.youtube.com/watch") > 0
    let youTubeId = null
    if (isYouTubeShortcut) {
      const parts = url.split('//youtu.be/')
      if (parts.length > 1)
        youTubeId = parts[1]
    }
    if (isYouTube) {
      const parts = url.split('?')
      if (parts.length > 1) {
        const params = parts[1].split('&')
        if (params.length > 0) {
          nameValue = params[0].split('=')
          youTubeId = nameValue[1]
        }
      }
    }
    return youTubeId
  }
  
  parseHTMLForMeta(url, html) {
    console.log(`parseHTMLForMeta`)
    // "meta":{"favicons":["http://cdn.cnn.com/cnn/.e/img/3.0/global/misc/apple-touch-icon.png"],"title":"CNN - Breaking News, Latest News and Videos"
    // <meta content="View the latest news and breaking news today for U.S., world, weather, entertainment, politics and health at CNN.com." property="og:description">
    // https://www.marketwatch.com/story/regulator-says-government-will-wipe-out-fannie-mae-and-freddie-mac-shareholders-if-needed-2019-10-22?mod=home-page
    // https://youtu.be/FdVGJw--ec4
    const isYouTubeShortcut = url.indexOf("//youtu.be/") > 0
    // onScanSite scanText: https://www.youtube.com/watch?v=RraKa-PKFPs
    const isYouTube   = url.indexOf("//www.youtube.com/watch") > 0 || url.indexOf("//m.youtube.com/watch") > 0
		const title       = this.tagContent(html, 'title')
		const titleLength = html.length
    console.log(`parseHTMLForMeta html length: ${titleLength}, title ${title}`)

    this.api.log("step 4 parseHTMLForMeta url = " + url + " title = " + title + " isYouTube = " + isYouTube)

    // console.log(`parseHTMLForMeta html`, html)
    const description = ''
    const meta = {
      title,
      description,
      site_name: title,
      favicons: [],
      fromHTMLScan: true // flag so that full scan will over-write
    }
    let extraImage = null
    const youTubeId = this.getYouTubeId(url)
    if (youTubeId)
      extraImage = `http://i3.ytimg.com/vi/${youTubeId}/hqdefault.jpg`

    this.api.log("step 5 parseHTMLForMeta url = " + url + " youTubeId = " + youTubeId + " extraImage = " + extraImage)

		console.log(`parseHTMLForMeta youTubeId ${youTubeId}`)
		const ogImage = this.partOfHtml(html, 'property="og:image" content="', '"')
		const ogImage2 = this.partOfHtmlBackwards(html, '<meta content="', '" property="og:image"')

    this.api.log("step 6 parseHTMLForMeta url = " + url + " ogImage = " + ogImage + " ogImage2 = " + ogImage2)

		if (ogImage && extraImage == null && ogImage.trim() != '') {
			console.log(`parseHTMLForMeta have ogImage ${ogImage}`)
			extraImage = ogImage
		}
		if (ogImage2 && extraImage == null && ogImage2.trim() != '') {
			console.log(`parseHTMLForMeta have ogImage2 ${ogImage2}`)
			extraImage = ogImage2
		}
	
    const images = extraImage ? [DefaultImage, extraImage] : [DefaultImage]
    this.results[url] = { 'meta' : meta, 'images' : images, startTime : Date.now() }
    this.filtered[url] = images
    const wantScan = true // extraImage == null
    console.log(`parseHTMLForMeta, extraImage: ${extraImage}, wantScan: ${wantScan}`)
    this.setState({ url, fetching: wantScan, wantScan, refresh : Date.now(), filterCount: this.filtered[url].length })
    Animated.timing( this.dropdown, { toValue : linkPostExpandedHeight, duration : 333 }).start( )
	}
	
	acceptUnparseableUrl(url) {
    console.log(`acceptUnparseableUrl`)
		// https://twitter.com/tedcruz/status/1339066634296844288?s=21
		const isTwitter = url.indexOf('twitter.com') > 0
    let title       = 'Unknown'
		let description = url
		let site_name   = title
		if (isTwitter) {
			const parts = url.split('/')
			title       = (parts.length > 2 ? parts[3] : 'Unknown')
			description = 'Twitter'
			site_name   = 'Twitter' // 2nd line of Link Post area
		}
    const meta = {
      title,
      description,
      site_name,
      favicons: [],
      fromHTMLScan: true // flag so that full scan will over-write
		}
    const images = [DefaultImage]
    this.results[url] = { 'meta' : meta, 'images' : images, startTime : Date.now() }
    this.filtered[url] = images
    const wantScan = false
    this.setState({ url, fetching: wantScan, wantScan, refresh : Date.now(), filterCount: this.filtered[url].length })
    Animated.timing( this.dropdown, { toValue : linkPostExpandedHeight, duration : 333 }).start( )
  }

  getYouTubeInfo = (youTubeId) => {
    const googleYouTubeAPIKey = `AIzaSyCVtGnKBzNZBkoRBteqFO1oNkdIx4mvCHs`
    console.log(`getYouTubeInfo youTubeId: ${youTubeId}`)
    let title = ''
    let description = ''
    let imageUrl = null
    // https://m.youtube.com/watch?v=pccGCL1ED2c&pp=sAQA
    const url = `https://www.youtube.com/watch?v=${youTubeId}`
    const youTubeInfoUrl = `https://www.googleapis.com/youtube/v3/videos?part=id%2Csnippet&id=${youTubeId}&key=${googleYouTubeAPIKey}`
    RNFetchBlob.fetch('GET', youTubeInfoUrl)
    .then( res => {
      const json = res.data
      const result = JSON.parse(json)
      console.log(`getYouTubeInfo json: ${json}`)
      if (result) {
        const data = result.items[0].snippet
        title = data.localized.title
        // https://youtu.be/aZFtuGqtASk missing standard
        imageUrl = data.thumbnails.standard ? data.thumbnails.standard.url : data.thumbnails.high.url
        const meta = {
          title,
          description: 'YouTube',
          site_name: 'YouTube',
          favicons: ['https://www.youtube.com/s/desktop/1802aa0e/img/favicon_144x144.png'],
          fromHTMLScan: true // flag so that full scan will over-write
        }
        const images = [imageUrl]
        this.results[url] = { 'meta' : meta, 'images' : images, startTime : Date.now() }
        this.filtered[url] = images
        const wantScan = false // extraImage == null
        this.setState({ url, fetching: wantScan, wantScan, refresh : Date.now(), filterCount: this.filtered[url].length })
      }
    })
/*
    $.getJSON( "https://www.googleapis.com/youtube/v3/videos?part=id%2Csnippet&id=szPyxPdzAGY&key=AIzaSyCVtGnKBzNZBkoRBteqFO1oNkdIx4mvCHs", function( data ) {
      //var obj = $.parseJSON(data);
       console.log(data.items[0].snippet.localized.title);
   });


    this.results[this.state.url] = null
    this.setState({ fetching : false })
*/    
  }
  
  scanSite(scanText, url) {
    console.log(`scanSite scanText: ${scanText}, url: ${url}`)
		const isTwitter = url.indexOf('twitter.com') > 0
    const timeStart = Date.now()
    const headers = { 
      'User-Agent' : 'Mozilla/5.0 (Macintosh; Intel Mac OS X 10.14; rv:89.0) Gecko/20100101 Firefox/89.0'
    }
    RNFetchBlob.fetch('GET', url, headers)
      .then( res => {
        const timeEnd = Date.now()

        this.api.log("step 1 initial GET of data for link post url = " + url + " time to GET = " + (timeEnd-timeStart))

        // this.setState({ fetching : false })
        var  redirects = false
           , status = false
        if(res.info) {
          redirects = res.info( ).redirects
          status = res.info( ).status
        }

        this.api.log("step 2 initial GET of data for link post url = " + url + " status = " + status)

				if( status == 200 && Array.isArray(redirects)) { // HTTP OK
					if (isTwitter) {
						console.log(`scanSite it is twitter, just add it in`)
						this.acceptUnparseableUrl(url)
					}
					else {
						console.log(`scanSite status 200, calling parseHMLForMeta`)
            this.api.log("step 3 initial GET of data for link post url = " + url + " res.data.length = " + res.data.length)
						this.parseHTMLForMeta(url, res.data)
						if (this.textview) {
							// UNUSED now
							console.tron.log(`scanSite get charList`)
							var charList = [ ]
							for( var i = 0; i < res.data.length ; ++ i )
								charList.push( res.data.charCodeAt(i) )
							console.log('ready to inject in text view ' + this.textview) // undef
							this.textview.injectJavaScript(`window.RNPayload = [${charList}]; console.log("dump = " + window.RNPayload); window.RNText = '${url}'; window.RNUrl = '${redirects[redirects.length-1]}'; ${this.siteMetaFetchCode}; ${this.siteMetaFetchFuncName}("${url}", "${scanText}"); true;`)
							console.tron.log(`textChanged after injectJavaScript`)
						}
					}
        } else { // in case of the obscure
					console.log(`scanSite status != 200, status: `, status)
					if (isTwitter) {
						console.log(`scanSite it is twitter, just add it in`)
						this.acceptUnparseableUrl(url)
					}
					else
						Animated.timing( this.dropdown, { toValue : 45, duration : 333 }).start( )
        }
      })
      .catch( error => {
        console.log(`Did not find site, or could not load source code error: ${error.message}`)
        alertView(I18n.t('postLink.badUrl'), '')
        this.results[this.state.url] = null
        this.setState({ fetching : false })
        Animated.timing( this.dropdown, { toValue : 45, duration : 333 }).start( )
      })
  }

  onScanSite() {

    if (Platform.OS == 'web') {
      
      alert("To make a link post, try the full Kargoe app, available on iPhone and Android now!")
      
      return 
    }
    
    // hit button
    let url = this.state.scanText
    console.tron.log(`onScanSite scanText: ${url}`)
    console.log(`onScanSite scanText: ${url}`)
    if (url == '') {
      Animated.timing( this.dropdown, { toValue : 45, duration : 333 }).start( )
      this.setState({url: ''})
      // TODO...
      return
    }
    if( url.match(/^https?:\/\//) ) {
      // no op
    } 
    else if( url.match(/^\/\//) )
      url = `http:${url}`
    else 
      url = `http://${url}`

    if (url.indexOf('https://youtu.be/') == 0) // mobile version missing social sharing meta data, like image
      url = url.replace('https://youtu.be/', 'https://www.youtube.com/watch?v=')

    if (url == this.state.url) {
      console.log(`just scanned this url, will not do again`)
      return
    }
    console.log(`onScanSite before init results, url ${url}`)
    this.results[this.state.url] = null
    this.results[aboutBlank] = null
    this.results[url] = null
    console.log(`onScanSite calling setState`)
    this.setState({ url: aboutBlank, images : [ ], selectedImageIndex : 0, hasScrolled : false })
    console.log(`onScanSite calling scanSite`)

    const youTubeId = this.getYouTubeId(url)
    if (youTubeId)
      this.getYouTubeInfo(youTubeId)
    else
      this.scanSite(this.state.scanText, url)
  }
  
  onStopScanSite() {
    console.tron.log(`onStopScanSite`)
  }

  textChanged = newText => {

    if (Platform.OS == 'web') {
      
      alert("To make a link post, try the full Kargoe app, available on iPhone and Android now!")

      return 
    }

    console.tron.log(`textChanged ${newText}`)
    const isPaste = newText.length - this.state.scanText.length > 2 // added more than one character
    if (isPaste) {
      Keyboard.dismiss()
      this.setState({scanText: newText, creatingPost: false}, () => this.onScanSite())
    }
    else {
      this.setState({scanText: newText, creatingPost: false})
    }

    // in case it is not down
    let v = this.dropdown.__getValue()
    console.log("v = " + v)
    Animated.timing( this.dropdown, { toValue : linkPostExpandedHeight, duration : 333 }).start( )

  }

/*
  textChanged = newText => {
    if( this.typingEvent ) {
      clearTimeout( this.typingEvent )
      this.typingEvent = null
    }
    this.realText = newText
    this.typing = Date.now( )
    // this.setState({ fetching : true, fetched : 'about:blank' })
    this.setState({ fetched : 'about:blank' })
    if (newText == '') {
      Animated.timing( this.dropdown, { toValue : 45, duration : 333 }).start( )
      this.setState({ url : '', images : [ ], selectedImageIndex : 0, hasScrolled : false })
    }
    let after = (start, text) => ( ) => {
      // show loader if we have asset
      var url = text
      // try to rescue non-strict urls
      if( url.match(/^https?:\/\//) ) {
        // no op
      } else if( url.match(/^\/\//) ) url = `http:${url}`
      else url = `http://${url}`
      this.setState({ url : url, images : [ ], selectedImageIndex : 0, hasScrolled : false })

      RNFetchBlob.fetch ( 'GET', url )
      .then( res => {
        // this.setState({ fetching : false })
        var  redirects = false
           , status = false
        if(res.info) {
          redirects = res.info( ).redirects
          status = res.info( ).status
        }
        if( status == 200 && Array.isArray(redirects)) { // HTTP OK
          this.setState({ fetching : true })
          console.tron.log(`textChanged get charList`)
          var charList = [ ]
          for( var i = 0; i < res.data.length ; ++ i )
            charList.push( res.data.charCodeAt(i) )
          this.refs.textview.injectJavaScript(`window.RNPayload = [${charList}]; window.RNText = '${url}'; window.RNUrl = '${redirects[redirects.length-1]}'; ${this.siteFetchCode}; ${this.siteFetchFuncName}("${url}");`)
          console.tron.log(`textChanged after injectJavaScript`)
        } else { // in case of the obscure
          Animated.timing( this.dropdown, { toValue : 45, duration : 333 }).start( )
        }
      })
      .catch( error => {
        this.setState({ fetching : false })
        console.log(error)
      })
    }
    this.typingEvent = setTimeout( after(this.typing, newText), 500 )
  }
*/

  webviewNavigate = nav => {
    this.realNavUrl = nav.url

    if(nav.url.match(/^http/)) {
      console.tron.log(`webviewNavigate: ` + JSON.stringify(nav))
      const url = nav.url
      if(this.webview) {
        console.tron.log(`webviewNavigate webview: ${url}, func name: ${this.siteImageFetchFuncName}, code length: ${this.siteImageFetchCode.length}`)
        console.log('ready to inject in webview url = ' + url)
        this.webview.injectJavaScript(`${this.siteImageFetchCode}; ${this.siteImageFetchFuncName}("${url}", "${this.state.scanText}"); true;`)
      }
    }
  }

/*
  webviewNavigate = nav => {
    this.realNavUrl = nav.url

    if(nav.url.match(/^http/)) {
      console.tron.log(`webviewNavigate: ` + JSON.stringify(nav))
      const stateChange = (url, depth) => ( ) => {
        if(this.refs.webview) {
          console.tron.log(`deep-reading: ${url}, depth: ${depth}`)
          this.refs.webview.injectJavaScript(depth? `${this.siteFetchFuncName}("${url}");`: `${this.siteFetchCode}; ${this.siteFetchFuncName}("${url}"); true;`)
        }
      }
      const runScan = (wait, depth) => setTimeout(stateChange(this.state.url, depth), wait)

      if( this.state.fetched !== nav.url ) {
        if( this.navStateChange ) {
          this.navStateChange.forEach(clearTimeout)
          this.navStateChange = false
        }
        this.setState({ fetched : nav.url })
        this.navStateChange = this.scanTimes.map(runScan)
      }
    }
  }
*/

  onErrorWebView = e => {
    // console.log("on error web view e = " + JSON.stringify(e))
    // console.tron.log("on error web view e = " + e.toString())
    this.api.log("onErrorWebView (link post) keys = " + JSON.stringify(Object.keys(e)))
    this.api.log("onErrorWebView (link post) nativeEvent keys = " + JSON.stringify(Object.keys(e.nativeEvent)))
  }

  filterResults = async url => {
  console.log("top of filter results url = " + url)
  let startFilterTime = Date.now()
  try {
    if (this.filtered[url])
      for (var i = 0; i < this.filtered[url].length; i++) {
        if (this.filtered[url][i].substr(0,4).toLowerCase() != 'http')
          this.filtered[url][i] = url + this.filtered[url][i]
      }
    const isHttps = url.substr(0,5).toLowerCase() == 'https'
    const protocol = isHttps ? 'https' : 'http'
    let images = this.results[url].images, 
    result = this.filtered[url] ? 
      this.filtered[url].reduce((li,u) => {li[u]=true; return li }, { }) : 
      { }
    // can be huge : console.log("in filter results images = " + JSON.stringify(images))
    // just print count 
    console.log("in filter results NUMBER of images = " + JSON.stringify(images.length))
    console.tron.display({name: 'filterResults', preview: "before loop", value: {isHttps: isHttps, url: url, filtered: this.filtered}})

    // can be huge:  console.log(JSON.stringify({isHttps: isHttps, url: url, filtered: this.filtered}))

    console.log(JSON.stringify({isHttps: isHttps, url: url /*, filtered: this.filtered*/}))

    let imageCount = Object.keys(this.filtered).length
    console.log("image count top of loop is " + imageCount)
    this.api.log("filterResults images.length = " + images.length)
    for( var i = 0; i < images.length /*&& imageCount < 10*/; ++i) {
      console.log("top of loop imageUrl = " + imageUrl)
      let imageUrl = images[i]
      let imageUrlLC = imageUrl.toLowerCase()
      if (imageUrlLC.substr(0,4) != 'http')
        if (imageUrlLC.substr(0,2) == '//')
          imageUrl = protocol + ':' + imageUrl
        else
          imageUrl = url + imageUrl
      const isJPEG = imageUrlLC.includes('jpg') || imageUrlLC.includes('jpeg')
      const isPNG  = imageUrlLC.includes('png')
      const isGIF  = imageUrlLC.includes('gif')
      const isSVG  = imageUrlLC.includes('svg')// was 'gif'
      const isLogo = imageUrlLC.includes('/logos/')
      const cnnAsset = imageUrlLC.includes('cnn.') && imageUrlLC.includes('/assets/') && isPNG
      if (isGIF || isSVG) {
        // console.tron.log(`filterResults skipping gif/svg: ${imageUrl}`)
        continue
      }
      if (isLogo) {
        // console.tron.log(`filterResults skipping logo: ${imageUrl}`)
        continue
      }
      if (cnnAsset) {
        // console.tron.log(`filterResults skipping cnn instructions for flash, login, etc ${imageUrl}`)
        continue
      }
      
      if (!this.alreadyGotImageSize) this.alreadyGotImageSize = {} // indexed by image url

      let w = 0
      let h = 0

      if (this.alreadyGotImageSize[imageUrl]) {
        console.log("re-using image size for " + imageUrl)
        const osize = this.alreadyGotImageSize[imageUrl]
        w = osize.width
        h = osize.height
      }
      else {
        const isize = await new Promise( (resolve, reject) => {
          console.log("imageUrl 1 = " + imageUrl)
          Image.getSize(imageUrl, (w,h) => resolve({ w, h }), e => resolve({ w : 0, h : 0 }))
          
        })
        w = isize.w 
        h = isize.h
      }

      this.alreadyGotImageSize[imageUrl] = {width: w, height: h}

      if( w < 225 || h < 150 ) {
        // console.tron.log(`filterResults skipping ${imageUrl} too small, width: ${w}, height: ${h}`)
        console.log(`filterResults skipping ${imageUrl} too small, width: ${w}, height: ${h}`)
        continue
      }
      console.tron.log(`filterResult image: ${imageUrl}, width: ${w}, height: ${h}, adding`)
      console.log(`filterResult image: ${imageUrl}, width: ${w}, height: ${h}, adding`)
      result[imageUrl] = true
      const imageList = Object.keys(result)
      imageCount = Object.keys(imageList).length
      console.log("image count is " + imageCount)
      this.filtered[url] = imageList
      this.setState({ refresh : Date.now() })
    }
    if (this.filtered[url].length == 0) {
      // console.tron.log(`filterResults, no results adding the default image`)
      this.filtered[url] = [DefaultImage]
      imageCount = 1
    }
    else if (this.filtered[url][0] != DefaultImage) {
      // console.tron.log(`filterResults, adding the default image`)
      this.filtered[url].unshift(DefaultImage)
      imageCount++
    }
    console.tron.log(`filterResults imageCount: ${imageCount}`)
    console.tron.display({name: 'filterResults', preview: "end", value: {filtered: this.filtered}})
    console.log(`filterResults imageCount: ${imageCount}`)
    console.log({name: 'filterResults', preview: "end", value: {filtered: this.filtered}})
    this.setState({ refresh : Date.now(), filterCount: this.filtered[url].length })
 }
  catch(e) {
       console.log("error in filter results = " + JSON.stringify(e))
       this.api.log("filterResults error = " + JSON.stringify(e))
  }

  let endFilterTime = Date.now()
  this.api.log("filterResults time = " + (endFilterTime-startFilterTime))
  }

  onMeta = e => {
    console.log("e.nativeEvent = " + e.nativeEvent)
    console.tron.display({name: 'PostLinkComp', preview: "onMeta", value: {nativeEvent: e.nativeEvent}})
    this.results = { }
    this.filtered = { }
    if (this.state.url != '') {
      try {
        var obj = JSON.parse(e.nativeEvent.data)
        if( obj.meta ) {
          //console.tron.display({name: 'PostLinkComp', preview: "onMeta2", value: {obj: obj, callingArgs: obj.callingArgs, scanText: obj.callingArgs[1]}})
          if (obj.callingArgs && obj.callingArgs.length && obj.callingArgs[1] != this.state.scanText) {
            console.tron.log(`onMeta callback is not for current scanText, ignoring`)
            console.log("onMeta callback is not for current scanText, ignoring")
            return
          }
          // if( Object.keys(obj.meta).length > 1 && typeof obj.url === 'string' ) {
          if( Object.keys(obj.meta).length > 0 && typeof obj.url === 'string' ) {
            console.log('found valid meta data')
            console.log(obj)
/*
            var uniques = obj.images ? Object.keys(obj.images.reduce((li,u) => { li[u] = true ; return li }, { })) : []
            this.results[obj.url] = { meta : JSON.parse(JSON.stringify(obj.meta))
                                    , images : JSON.parse(JSON.stringify(uniques))
                                    , startTime : Date.now( ) }
            this.filtered[obj.url] = obj.meta.image ? [obj.meta.image]: [ ]
            this.filterResults(obj.url)
*/
            const bodyImages = obj.images ? Object.keys(obj.images.reduce((li,u) => { li[u] = true ; return li }, { })) : [] // Object.keys(obj.images.reduce(list, { }))
            const allImages = obj.meta.image ? [obj.meta.image, ...bodyImages] : bodyImages
            console.log("ready to set results for url " + this.state.url)
            console.log("ready to set results allImages " + JSON.stringify(allImages))
            this.results[this.state.url] = { 'meta' : JSON.parse(JSON.stringify(obj.meta))
                                           , 'images' : allImages
                                           , startTime : Date.now( )
                                           }
            this.filtered[this.state.url] = [] // obj.meta.image? [obj.meta.image]: [ ]
            this.filterResults(this.state.url)
            this.setState({ refresh : Date.now() })
            Animated.timing( this.dropdown, { toValue : linkPostExpandedHeight, duration : 333 }).start( )
          } else {
            Animated.timing( this.dropdown, { toValue : 45, duration : 333 }).start( )
          }
        } else {
          Animated.timing( this.dropdown, { toValue : 45, duration : 333 }).start( )
        }
      } catch ( error ) {
        console.tron.log(`onMeta error: ${error.message}`)
        Animated.timing( this.dropdown, { toValue : 45, duration : 333 }).start( )
      }
    }
    this.setState({ refresh : Date.now() })
  }

  onMessage = e => {
    // can be huge console.log("on message = " + JSON.stringify(e.nativeEvent))
    console.log("on message recvd")
    if (this.state.url != '') {
      try {
        var obj = JSON.parse(e.nativeEvent.data)
        //console.log("obj = " + e.nativeEvent.data)
        console.log("obj parsed = " + obj) 
        this.api.log("onMessage, obj keys count = " + Object.keys(obj).length)
        //console.tron.display({name: 'PostLinkComp', preview: "onMessage", value: {nativeEvent: e.nativeEvent, obj: obj}})
        if (obj.callingArgs && obj.callingArgs.length && obj.callingArgs[1] != this.state.scanText) {
          console.tron.log(`onMessage callback is not for current scanText, ignoring`)
          console.log("onMessage callback is not for current scanText, ignoring")
          this.api.log("onMessage, callback is not for current scanText, ignoring")
          return
        }
        if( obj.meta ) {
          console.tron.log('got deep images')
          console.log('got deep images')
          const list = (li,u) => { li[u] = true ; return li }
          console.log("after list =")
          // can be huge
          //console.log("this.results = " + JSON.stringify(this.results))
          console.log("this.state.url = " + this.state.url)
          console.log("obj meta " + JSON.stringify(obj.meta))
          console.log("obj keys len " + Object.keys(obj.meta).length)
          console.log("this.state.url " + this.state.url)
          console.log('this.results[this.state.url] = ' + this.results[this.state.url])
          // only getting favicons in meta
          if( ! this.results[this.state.url] ) {
            console.tron.log('!this.results[this.state.url]')
            console.log('!this.results[this.state.url]')
            console.log("loc B")
            this.api.log("onMessage, Object.keys(obj.meta).length = " + Object.keys(obj.meta).length)

            if( Object.keys(obj.meta).length > 0 ) { //  > 1 // why does meta need to have more than one entry???
              console.log('javascript meta obj.images = ' + JSON.stringify(obj.images))
              this.api.log("onMessage, obj.images = " + obj.images)

              const bodyImages = obj.images ? Object.keys(obj.images.reduce((li,u) => { li[u] = true ; return li }, { })) : [] // Object.keys(obj.images.reduce(list, { }))
              const allImages = obj.meta.image ? [obj.meta.image, ...bodyImages] : bodyImages
              console.log("allImages = " + JSON.stringify(allImages))
              this.api.log("onMessage, obj.images = " + JSON.stringify(allImages))

              this.results[this.state.url] = { 'meta' : JSON.parse(JSON.stringify(obj.meta))
                                             , 'images' : allImages
                                             , 'startTime' : Date.now( )
                                             }
              this.filtered[this.state.url] = [] // obj.meta.image? [obj.meta.image]: [ ]
              this.filterResults(this.state.url)
              this.setState({ refresh : Date.now() })
              Animated.timing( this.dropdown, { toValue : linkPostExpandedHeight, duration : 333 }).start( )
            }
          } else if( Object.keys(obj.meta).length >= 1 && this.results[this.state.url] ) { // was > 1 but huffpost only had 1 key in their meta
            //console.tron.log('obj.meta && this.results[this.state.url]')
            this.api.log("onMessage, second branch, meta keys length = " + Object.keys(obj.meta).length)
            console.log('obj.meta && this.results[this.state.url]')
            console.log("loc C")
            const existingMeta = this.results[this.state.url].meta
            console.log('existing meta = ' + JSON.stringify(existingMeta))
            if (typeof existingMeta.fromHTMLScan != 'undefined') {
                let meta = JSON.parse(JSON.stringify(obj.meta))
                if (typeof meta.title != 'undefined') {
                  console.log('ready to decode meta title')
                  meta.title = entities.decode(meta.title)
                  console.log("meta title = " + meta.title)
                  this.api.log("onMessage, meta title = " + meta.title)
                }
                this.results[this.state.url].meta = meta
            }
            console.log('b4 exp')
            var exp = this.results[this.state.url].images.reduce(list, { })
            console.log('after exp')
            exp = obj.images.reduce(list, exp)
            this.results[this.state.url].images = Object.keys(exp)
            this.api.log("onMessage, ready to filter images length = " + this.results[this.state.url].images.length)
            this.filterResults(this.state.url)
            this.setState({ refresh : Date.now() })
          }
          console.log("ready to set fetching false")
          this.setState({ fetching : false })
        }
      } catch ( error ) {
        //console.tron.log(`PostLinkComponent onMessage`, error)
        console.log(`PostLinkComponent onMessage` + JSON.stringify(error))
        this.api.log("onMessage, catch = " + JSON.stringify(error))
      }
    }
  }

  imageSize = async ( url ) => {
    console.tron.log(`imageSize url: ${url}`)
    console.log("image size 1")
    if( ! url ) return Promise.resolve({ h : 1242, w : 2208 })
    let result = {w: 0, h: 0}
    try {
      console.log("ready to call 2 in imageSize")
      
      result = await new Promise( (resolve, reject) => {
      console.log("ready to call getSize url = " + url) 
      Image.getSize( url, (w,h) => resolve({ w : w, h : h }), (err) => resolve({ w : 0, h : 0 }) )  // this is failing, add a reject error handler
      })
    }
    catch(e) {
      console.log("error in imageSize post link component " + JSON.stringify(e))
    }
    return result
  }

/*
  resizeImage = async ( url, size, display = { width : 1242, height : 1242 }) => {
    console.tron.log(`resizeImage url: ${url}, size: ${size}, display: ${display}`)
    let b64 = await new Promise( (resolve, reject) => {
      let minor = size.w > size.h? size.h: size.w
      ImageEditor.cropImage( url
        , { offset : { x : (size.w/2)-(minor/2), y : (size.h/2)-(minor/2) }
          , size : { width : minor, height : minor }
          , displaySize : display
          , resizeMode : 'contain'
          }
        // resolve
        , uri => ImageStore.getBase64ForTag(uri, b64 => resolve(b64), console.warn)
        // reject
        , reject
        )
    })
    console.tron.log(`resizeImage complete`)
    return b64
  }
*/

  resizeImage = async ( url, size, display = { width : 1242, height : 1242 }) => {
    console.tron.log(`resizeImage url: ${url}, size: ${size.w}x${size.h}, display: ${display.width}x${display.height}`)
    let b64 = await new Promise( (resolve, reject) => {
      let minor = size.w > size.h? size.h: size.w
      ImageEditor.cropImage( url
        , { offset : { x : 0, y : 0 }
          , size: { width: size.w, height: size.h }
          , displaySize : display
          , resizeMode : 'cover' // contain shows bars
          }
        // resolve
        , uri => ImageStore.getBase64ForTag(uri, b64 => resolve(b64), console.warn)
        // reject
        , reject
        )
    })
    console.tron.log(`resizeImage complete`)
    return b64
  }

  makePostLink = async action => {
    console.tron.log(`makePostLink start`)
    console.log("makePostLink start")

    let getPhoto = false
    if (this.filtered[this.state.url] /*&& this.state.selectedImageIndex != LIBRARY_INDEX*/) {
      console.log("n images available for link post = " + this.filtered[this.state.url].length)
      if (this.filtered[this.state.url].length == 0 && this.state.selectedImageIndex != LIBRARY_INDEX) 
        getPhoto = true
    } else {

      if (this.state.selectedImageIndex != LIBRARY_INDEX)
        getPhoto = true
    }

    if (getPhoto && !this.getPhotoThenPost) {                   // dont do it again if we did it once
      this.getLibraryPhoto(true) // sets this.getPhotoThenPost
      return
    }

    if (this.getPhotoThenPost) // we just got a photo because image list was empty, so make sure to use it
      this.state.selectedImageIndex = LIBRARY_INDEX // dont use set state because that is async

    this.getPhotoThenPost = false // finally clear this so it doesnt happen again

    this.setState({hidePostButton: true, creatingPost: true}) // debounce
    setTimeout(() => {
      this.setState({hidePostButton: false})
    }, 2000)

    Animated.timing( this.dropdown, { toValue : 45, duration : 333 }).start( ) // animate the dropdown closed

    this.props.progress(0.1)
    const YouTubeLinkType = [ /youtu.be\/([^\/]+)/, /v=([^&]+)/, /\/v\/([^?\/]+)/ ]
    // too much can fail here
    // separate it out so we can find out which fails
    /*
    var result = this.results[this.state.url], m = result.meta
      , site = m.site_name
      , isYouTube = site && site === 'YouTube'
      , ytMatch = YouTubeLinkType.map(this.state.url.match.bind(this.state.url)).filter(v=>v)
      , YTID = ytMatch.length? ytMatch[0][1] : false
      , parts = this.state.url.match(/(http|https):\/\/([^\/]+)(.*)/)
    */
    var result = this.results[this.state.url], m = result.meta
    console.log("loc1")
    var site = m.site_name
    console.log("loc2")
    var isYouTube = site && site === 'YouTube'
    var ytMatch = YouTubeLinkType.map(this.state.url.match.bind(this.state.url)).filter(v=>v)
    console.log("loc3")
    var YTID = ytMatch.length? ytMatch[0][1] : false
    console.log("loc4")
    var parts = this.state.url.match(/(http|https):\/\/([^\/]+)(.*)/)
    console.log("m = " + JSON.stringify(m))
    console.tron.display({name: 'makePostLink',preview: "result",value: {parts: parts, m: m, result: result, filtered: this.filtered}})
    console.log("result.meta.title = " + JSON.stringify(result.meta.title))
    if( ! result.meta.title )
      result.meta.title = result.url
    Object.assign(result.meta, { pasted_url : this.state.url, favicon : (m && m.favicions && m.favicons.length) ? m.favicons[0]: (parts[1]+'://'+parts[2]+'/favicon.ico') })
    // this.setState({ fetching : true })
    console.log("loc5")
    Keyboard.dismiss ( )

    let url = this.filtered[this.state.url]&&this.filtered[this.state.url][this.state.selectedImageIndex]? this.filtered[this.state.url][this.state.selectedImageIndex]: DefaultImage

    if (this.state.selectedImageIndex === LIBRARY_INDEX)
      url = this.customLibraryImageObject.uri

    console.log("loc6")
    console.tron.log(`makePostLink url: ${url}`)

    let size = {w:0,h:0}
    try {
      size = await this.imageSize( url ) // if this fails, rest of code fails silently
    }
    catch(e) {
      console.log("awit imageSize failed in post link component e = " + JSON.stringify(e))
    }
    console.tron.log(`makePostLink size: ${size}`)
    console.log("ready to make b64 of size " + JSON.stringify(size))

    const imageWidth = size.w
    const imageHeight = size.h
    const rawAspectRatio = imageHeight != 0 ? imageWidth / imageHeight : 1
    let   aspectRatio = closestKargoeRatio(rawAspectRatio)
    let   origSize = {w: size.w, h: size.h}
    size = {w: imageWidth, h: imageWidth * aspectRatio}
    
    if (imageWidth == 0 || imageHeight == 0) { // if this is a bad image, use a generic one
      aspectRatio = 1
      url = DefaultImage 
      // this better work because it is our default image now
      size = await this.imageSize( url ) // if this fails, rest of code fails silently
      origSize = size
    }
    let b64 = await this.resizeImage( url, origSize, { width: 1242, height: Math.floor(1242 / aspectRatio)} )
    console.log("b64 len = " + b64.length)
    console.tron.log(`makePostLink got b64`)
    let b64Thumb = await this.resizeImage( url, origSize, { width : 400, height : Math.floor(400 / aspectRatio) })
    this.props.progress(0.3)
    console.tron.log(`got ${JSON.stringify(size)}`)
    result = JSON.parse(JSON.stringify(result)) // make writable
    if (result.title == '') result.title = this.state.url
    result.meta = JSON.parse(JSON.stringify(result.meta))
    if (result.meta.title === undefined) result.meta.title = this.state.url // meta title is what is not working on huffpost
    console.log("result before if action === tag " + JSON.stringify(result))
    if( action === 'tag' ) {
      // no more.  just edit the post after it has been made
      this.props.progress(1)
      this.setState({ fetching : false, spinning: false, url : aboutBlank })
      // try passing along image detail, like Create (from Camera)
      const imageDetail = {
        "uri": url,
        "uriThumb": url,
        "width": origSize.w,
        "height": origSize.h,
        "base64": b64,
        "base64Thumb": b64Thumb,
        // "stillImageAsBase64":  // required?
      }
      this.props.nav.navigate ('editPost', {  
        data : {
          Caption : ' '
          , IsVideo : false, ISell : [ ], TheySell : [ ], UserTags : [ ]
          , LocationCoord : '', LocationName : '', LocationId : ''
          , MediaType : 'JPEG', AspectRatio: aspectRatio
          , Type : isYouTube ? 2 : 1 // YouTube -> 2, LinkPost -> 1
          , MiniMeta : isYouTube ? YTID : false // YouTube -> VideoId
          , Meta : result.meta
          , UserId : this.props.auth.user.UserId
          , b64 : b64, thumb : b64Thumb
        }
        , postType : 'LINK'
        , image: imageDetail
      })
    } else {
      this.api.createPost({
        Caption : ' '
      , IsVideo : false, ISell : [ ], TheySell : [ ], UserTags : [ ]
      , LocationCoord : '', LocationName : '', LocationId : ''
      , MediaType : 'JPEG', AspectRatio: aspectRatio
      , Type : isYouTube ? 2 : 1 // YouTube -> 2, LinkPost -> 1
      , MiniMeta : isYouTube ? YTID : false // YouTube -> VideoId
      , Meta : result.meta
      }).then( resp => {
        this.props.progress(0.5)
        let post = resp.data.data[0]
        const { PostId, bucket, image, thumbImage } = post
        // upload image to s3
        let headers = { 'Content-Type' : 'application/octet-stream' }
        //console.log('have b64 = ' + b64)
        console.log('ready to fetch blob for ' + image._url + ' b64.length = ' + b64.length)
        RNFetchBlob.fetch ( 'PUT', image._url, headers, b64 )
        .then( ( ) => {
          this.props.progress(0.65)
          RNFetchBlob.fetch ( 'PUT', thumbImage._url, headers, b64Thumb )
        } )
        .then( ( ) => {
          this.props.progress(0.8)
          this.api.completePost ( PostId ).then(( ) => {
            if (false && action === 'tag') {
              this.props.progress(1)
              this.props.nav.navigate ('editPost', {  data : post, postType: 'edit' })
            }
            else {
              // refresh the wall once we know the post is made
              this.props.progress(1)
              this.props.onRefresh( )
            }
          }).catch((e) => {console.log("catch loc X " + JSON.stringify(e))})
        })
      }).catch((e) => {
        this.props.progress(0)
        console.tron.log(`makePostLink error: ${e.message}`)
        this.postlinkinput.wrappedInstance.clear( )
        this.setState({ fetching : false, url : aboutBlank })
        Animated.timing( this.dropdown, { toValue : 45, duration : 333 }).start( )
        console.log("catch Y " + JSON.stringify(e))
      })
      // immediately after calling create post asynchronously
      console.tron.log(`makePostLink clear things after done`)
      this.postlinkinput.wrappedInstance.clear( ) // clear the text box
      this.setState({ fetching : false, url : aboutBlank }) // set the dropdown state
      Animated.timing( this.dropdown, { toValue : 45, duration : 333 }).start( ) // animate the dropdown closed
    }
  }

  carouselImage = (url, index) => {
    // console.tron.log(`carouselImage url ${url}`)
    console.log("ready to call get size for carousel url = " + url)
    Image.getSize(url, (w,h) => success({ w : w, h : h }))

    function success(size) {
       console.log("size = " + JSON.stringify(size))
    }

    return this.state.selectedImageIndex===index ? (
      <TouchableOpacity style={{ margin : 2, padding : 1, height : screenWidth*thumbWidthRatio+8, width : screenWidth*thumbWidthRatio+8, borderWidth : 3, borderColor : 'black' }} onPress={( ) => this.setState({ selectedImageIndex : index})}>
          <Image source={{ uri: url }} resizeMode='cover' style={{ width : screenWidth*thumbWidthRatio, height : screenWidth*thumbWidthRatio, backgroundColor: '#D7D7D7' }} />
      </TouchableOpacity>
    ) :
    (
      <TouchableOpacity style={{ margin : 2, padding : 4, height : screenWidth*thumbWidthRatio+8, width : screenWidth*thumbWidthRatio+8, borderWidth : 0, borderColor : 'black' }} onPress={( ) => this.setState({ selectedImageIndex : index})}>
          <Image source={{ uri: url }} resizeMode='cover' style={{ width : screenWidth*thumbWidthRatio, height : screenWidth*thumbWidthRatio, backgroundColor: '#D7D7D7' }} />
      </TouchableOpacity>
    )

  }

  gotCustomImage = (response) => {
    console.log("gotCustomImage = " + JSON.stringify(Object.keys(response)))
    this.customLibraryImageObject = response // save it all for now
    this.setState({renderBump: this.state.renderBump + 1}) // 
    if (this.getPhotoThenPost) this.makePostLink('post')
  }

  // if thenPost is true, will create the post right after user selects the photo
  getLibraryPhoto = (thenPost) => {
    console.log("get library photo")
    this.getPhotoThenPost = thenPost // because tricky to bind an arg to gotCustomImage because response is first arg hmm

    launchImageLibrary({ mediaType: 'photo',  
                         maxWidth: 1024,
                         quality: 1,
                         includeBase64: false // may not be needed do in standard flow
                       }, this.gotCustomImage)
  }

  extraData = valid => {
    const haveUrl = !!this.state.url && this.state.url.length > 0
    const siteDetails = this.results[this.state.url] ? this.results[this.state.url] : null
    const meta = siteDetails ? siteDetails.meta : null
    const metaName = meta ? (meta.title ? meta.title : meta.url) : null
    const url  = siteDetails ? siteDetails.url : null
    // console.tron.display({name: 'extraData', preview: "render", value: {haveUrl, siteDetails, valid, results: this.results, filtered: this.filtered}})
    if (!haveUrl)
      return null
    //           {true || (siteDetails && (Date.now( ) - siteDetails.startTime) < 200000) &&  w*0.1825

    // strip out default image before rendering and giant urls which may indicate a problem in code that generates them
    this.filtered[this.state.url] = this.filtered[this.state.url].filter((x) => {
      if (x.length > 1024) return false // long url could be trouble, ignore it
      return x !== DefaultImage
    })

    return valid && !this.state.creatingPost ? (
      <View style={{ width : '100%' }}>
        <Text style={{ margin : 5, marginLeft : 15, fontSize : 12, fontFamily: Fonts.style.font.bold }} numberOfLines={2}>{metaName}</Text>
        <View style={{flexDirection: 'row'}}>
          <Text style={{ height: 20, marginLeft : 30, fontSize : 12, fontFamily: Fonts.style.font.bold }}>Choose Cover Image: </Text>
          <TouchableOpacity style={{ height: 20, marginLeft: 30}} onPress={this.getLibraryPhoto}><Text style={{fontSize : 12, fontFamily: Fonts.style.font.bold}} >From Photo Library</Text></TouchableOpacity>
        </View>
        <ScrollView horizontal={true} onScroll={( ) => this.setState({ hasScrolled : true })}>
          {this.customLibraryImageObject && this.carouselImage(this.customLibraryImageObject.uri, LIBRARY_INDEX)}
          {this.filtered[this.state.url] && this.filtered[this.state.url].map(this.carouselImage)}
          {this.state.showSpinner && this.state.wantScan && 
             <View style={{ margin: 2, padding: 4, width: screenWidth*thumbWidthRatio+8, height: screenWidth*thumbWidthRatio+8, justifyContent : 'center', alignItems : 'center' }}>
               <LottieView style={{ width: 75, height: 75, opacity: 0.25 }}
                ref={ spinner => {
                  if(spinner) {
                    this.refs.spinner = spinner
                    spinner.play( )
                  }
                }}
                loop autoPlay
                source={Images.spinnerDark}
               />
             </View>
          }
        </ScrollView>
        {this.filtered[this.state.url] && this.filtered[this.state.url].length > 3 && !this.state.hasScrolled &&
          <Image source={Images.postlinkScrollIndicator} resizeMode='contain' style={{ position : 'absolute', bottom : screenWidth*0.1575+70, right : 0, zIndex : 2, width : 45, height : 45 }} />
        }
        <View style={{ width : '100%', height : 70, flexDirection : 'row', alignItems : 'flex-start', justifyContent : 'center' }}>
          <TouchableHighlight onPress={() => this.makePostLink('tag')} style={{ marginRight : 25 }}>
              <Image source={Images.postlinkAddTag} resizeMode='contain' style={{ width : 100, height : 35 }}/>
          </TouchableHighlight>
          {!this.state.hidePostButton && <TouchableHighlight onPress={() => this.makePostLink('post')}>
              <Image source={Images.postlinkPost} resizeMode='contain' style={{ width : 100, height : 35 }}/>
          </TouchableHighlight>}
        </View>
      </View>
    ) : null
  }

  render ( ) {
    // console.tron.log(`PostLinkComponent render ${this.state.url}`)
    var iconContainer = { marginRight : 5, height: 35, width: 35
                        , borderColor: '#8692b7'
                        , borderWidth: 1
                        , justifyContent: 'center'
                        , alignItems: 'center'
                        }
      , iconBorder = { width: 30, height: 30 }
    const { toogleGridView, viewMode }  = this.props
    const validPostLinkMeta = this.results[this.state.url]
    const showExtra = this.state.fetching || validPostLinkMeta // !this.state.fetching && validPostLinkMeta
    // console.log(`would show meta data: ${showExtra? 'true': 'false'}`)
    // if(showExtra) console.log(validPostLinkMeta.images) // print image list _every_ render
    // TODO - fix onMessage WebView red screen
    // https://github.com/facebook/react-native/issues/10865
    const modeIcon = viewMode == 'grid' ? Images.gridProfile : viewMode == 'list' ? Images.listProfile : Images.mosaicProfile
    // position: 'absolute', top: statusAndNavHeight 
    // for WKWebView allowsInlineMediaPlayback={true} if we dont do this, videos go full screen
    const haveUrl = !!this.state.url && this.state.url.length > 0
    //console.log('test post link render')
    return (
      <View style={{}}>
        <Animated.View style={{ width : '100%', marginTop : 10, height : this.dropdown, flexDirection : 'row', paddingBottom : 10, flexWrap : 'wrap', alignItems : 'flex-start' }}>
          <View style={{ marginLeft : 10, width : screenWidth-50, height : 35, flexDirection : 'row', alignItems : 'center', justifyContent : 'flex-start' }}>
            <TextInput style={{ paddingLeft: 10, paddingTop: 0, paddingBottom: 0, marginLeft: 5, marginRight: 5,
                height: 35, width: screenWidth-50-20,
                borderColor: 'black', borderRadius: 10, borderWidth: 1,
                fontSize: 16, fontFamily: Fonts.style.font.regular, color: 'black',
                /* lineHeight : 33 */
              }}
              clearButtonMode={'always'}
              ref = {(ref) => this.postlinkinput = ref}
              autoCapitalize='none' autoCorrect={false}
              placeholderTextColor = 'grey'
              placeholder={I18n.t('followersProfile.title')}
              onChangeText={this.textChanged}
              placeholderTextColor="#DCDCDC"
              returnKeyType="done"
              onSubmitEditing={this.onScanSite}>
            </TextInput>
          </View>
          <View style={iconContainer}>
            <TouchableHighlight onPress={toogleGridView} underlayColor='grey'>
              <Image source={modeIcon} style={iconBorder} />
            </TouchableHighlight>
          </View>
          {haveUrl && this.extraData(showExtra)}
          {haveUrl && this.state.wantScan && <View style={{ width : 1, height : 1, position : 'absolute', display : 'none' }}>
            <WebView
              ref={(ref) => this.webview = ref}
              userAgent={this.userAgent}
              source={{ uri : this.state.url }}
              style={{ width : screenWidth, height : screenHeight, opacity : 0 }}
              javaScriptEnabled={true}
              startInLoadingState={true}
              mixedContentMode={'compatibility'}
              allowUniversalAccessFromFileURLs={true}
              onMessage={this.onMessage}
              onError={this.onErrorWebView}
              onNavigationStateChange={this.webviewNavigate}
              allowsInlineMediaPlayback={true}
            />
          </View>}
        </Animated.View>
      </View>
    )
  }
}

/*
<WebView
  ref={(ref) => this.textview = ref}
  userAgent={this.userAgent}
  source={{ uri : aboutBlank }}
  style={{ width : 300, height : 150 , opacity : 1, borderWidth: 1, borderColor: 'green', marginTop: 2 }}
  javaScriptEnabled={true}
  startInLoadingState={true}
  mixedContentMode={'compatibility'}
  allowUniversalAccessFromFileURLs={true}
  onMessage={this.onMeta}
  onError={this.onErrorWebView}
  allowsInlineMediaPlayback={true}
/>
*/

const mapStateToProps = state => {
  return { 
    auth : state.auth,
  }
}
const mapDispatchToProps = dispatch => { 
  return {
    progress: (amount) => dispatch(PostsActions.createStandardPostProgress(amount)),
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(PostLinkComponent)

// Fetch is embedded into the web page, so it can report back things like favorite icon, images, etc

// add jQuery ready pure js function to let page load up assets
// https://github.com/jfriend00/docReady

function siteImageFetch() {
  console.log("***** top of site image fetch");
  var callingArgs = arguments;
  var scanTries = 0;
  var videoCount = 0;
  
  function disableAutoPlay() {
    window.document.querySelectorAll('video')
      .forEach((video) => {
           // video.removeAttribute('autoplay')
           video.parentNode.removeChild(video)
           videoCount++
      })
  }
  disableAutoPlay();
  setInterval(disableAutoPlay, 250);
  console.log("***** site image fetch loc 1");
	(function(funcName, baseObj) {
		"use strict";
		// The public function name defaults to window.docReady
		// but you can modify the last line of this function to pass in a different object or method name
		// if you want to put them in a different namespace and those will be used instead of 
		// window.docReady(...)
		funcName = funcName || "docReady";
		baseObj = baseObj || window;
		var readyList = [];
		var readyFired = false;
		var readyEventHandlersInstalled = false;
		
		// call this when the document is ready
		// this function protects itself against being called more than once
		function ready() {
            console.log("****** ready");
			if (!readyFired) {
				// this must be set to true before we start calling callbacks
				readyFired = true;
				for (var i = 0; i < readyList.length; i++) {
					// if a callback here happens to add new ready handlers,
					// the docReady() function will see that it already fired
					// and will schedule the callback to run right after
					// this event loop finishes so all handlers will still execute
					// in order and no new ones will be added to the readyList
					// while we are processing the list
					readyList[i].fn.call(window, readyList[i].ctx);
				}
				// allow any closures held by these functions to free
				readyList = [];
			}
		}
		
		function readyStateChange() {
            console.log("****** ready state change " + document.readyState);
			if ( document.readyState === "complete" ) {
				ready();
			}
		}
		
		// This is the one public interface
		// docReady(fn, context);
		// the context argument is optional - if present, it will be passed
		// as an argument to the callback
		baseObj[funcName] = function(callback, context) {
			if (typeof callback !== "function") {
				throw new TypeError("callback for docReady(fn) must be a function");
			}
			// if ready has already fired, then just schedule the callback
			// to fire asynchronously, but right away
			if (readyFired) {
				setTimeout(function() {callback(context);}, 1);
				return;
			} else {
				// add the function and context to the list
				readyList.push({fn: callback, ctx: context});
			}
			// if document already ready to go, schedule the ready function to run
			// IE only safe when readyState is "complete", others safe when readyState is "interactive"
			if (document.readyState === "complete" || (!document.attachEvent && document.readyState === "interactive")) {
				setTimeout(ready, 1);
			} else if (!readyEventHandlersInstalled) {
            // otherwise if we don't have event handlers installed, install them
                console.log("*** installing event listeners");
				if (document.addEventListener) {
					// first choice is DOMContentLoaded event
					document.addEventListener("DOMContentLoaded", ready, false);
					// backup is window load event
					window.addEventListener("load", ready, false);
				} else {
					// must be IE
					document.attachEvent("onreadystatechange", readyStateChange);
					window.attachEvent("onload", ready);
				}
				readyEventHandlersInstalled = true;
			}
		}
	})("docReady", window);
	// modify this previous line to pass in your own method name 
	// and object for the method to be attached to
	
	function scanForImagesInner(urlReference) {
    console.log("*** scan for images inner for urlReference = " + urlReference);
    try {
      var SH = document
        , text = window.RNPayload? String(window.RNPayload.map(function(code){return String.fromCodePoint(code)}).join('')): false
        , parts = (window.RNUrl? window.RNUrl: window.location.href).match(/(http|https):\/\/([^\/]+)(.*)/)
        , isHTTPS = ('' + window.RNUrl).substr(0,6).toLowerCase() == 'https:'
      if(text) {
        SH = document.createElement('html')
        SH.innerHTML = text
      }

      // https://gist.github.com/donut/1293825
      function styleImages() {
        var sheets = document.styleSheets;
        var hash = {}, sheet, rules, rule, url, match;
        // loop the stylesheets
        for (var sheetIdx=0, sheetsLen=sheets.length; sheetIdx<sheetsLen; ++sheetIdx) {
          sheet = sheets[sheetIdx];
          // ie or w3c stylee rules property?
          rules = sheet.rules ? sheet.rules : sheet.cssRules;
          // loop the rules
          if (rules)
            for (var ruleIdx=0, rulesLen=rules.length; ruleIdx<rulesLen; ++ruleIdx) {
              rule = rules[ruleIdx];
              if (rule.selectorText && rule.style.cssText) {
                // check if there's a style setting we're interested in..
                if (rule.style.cssText.match(/background/)) {
                  // ..and if it has an url in it, put it in the hash
                  match = /url\(([^)]*)\)/.exec(rule.style.cssText);
                  if (match) {
                    // hash[match[1]] = true;
                    url = match[1].replace(/\"/g, '')
                    var lowerUrl = url.toLowerCase();
                    if (lowerUrl.substr(0,2) == '//') {
                      url = (isHTTPS ? 'https:' : 'http:') + url;
                    }
                    else if (lowerUrl.substr(0,5) != 'data:') {
                      if (lowerUrl.substr(0,4) != 'http') {
                        url = parts[1] + '://' + url;
                      }
                      hash[url] = true;
                    }
                  }
                }
              }
            } // for
        }
        var urls = [];
        for (url in hash) { urls.push(url); }
        console.log("*** " + urls.length + " images found");
        return urls;
      }
      
      function getElementBackgroundImages() {
        console.log("**** get element background images");
        var elementNames = ["div", "body", "td"] // Put all the tags you want bg images for here
        var allBackgroundURLs = new Array();
        elementNames.forEach( function(tagName) {
             var tags = document.getElementsByTagName(tagName);
             var numTags = tags.length;
             for (var i = 0; i < numTags; i++) {
                 tag = tags[i];
                 if (tag.style.background.match("url")) {
                     var bg = tag.style.background;
                     allBackgroundURLs.push(bg.substr(bg.indexOf("url") + 4, bg.lastIndexOf(")") - (bg.indexOf("url") + 4) ) );
                 }
             }
        });
        console.log("*** " + allBackgroundURLs.length + " background images found");
        return allBackgroundURLs;
      }
              
      var props = { title : [ 'og:title', 'twitter:title' ]
                  , description : [ 'og:description' ]
                  , image : [ 'og:image', 'twitter:image', 'twitter:image:src' ]
                  , alt : [ 'twitter:image:alt' ]
                  , 'site_name' : [ 'og:site_name' ]
                  , site : [ 'twitter:site' ]
                  , type : [ 'og:type' ]
                  }
      var metaPtr = SH.getElementsByTagName('meta')
      var meta = Array.apply( [ ], metaPtr )
                            .reduce(function(result,iter) {
                              function g(a,b) { return iter.getAttribute(a) || iter.getAttribute(b) }
                              var key = g('property', 'name'), value = g('content', 'value')
                              if(!key||!value||!key.length||!value.length) return result
                              for( var k in props )
                                for( var j = 0 ; j < props[k].length; ++ j )
                                  if( key === props[k][j] || key === k ) { result[k] = value ; break }
                              return result
                            }
                            , { favicons : Array.apply( [ ], SH.getElementsByTagName('link') )
                                            .reduce(function( result, iter ) {
                                              var rel = iter.getAttribute('rel')
                                              if( ! rel || ! rel.match(/icon/) )
                                                return result
                                              var href = iter.getAttribute('href')
                                              // no relative links allowed
                                              if( href ) {
                                                if (href.length > 4 && href.substr(-4) == '.ico')
                                                  return result
                                                if (href.substr(0,2) == '//')
                                                  result.push((isHTTPS ? 'https:' : 'http:') + href)
                                                else
                                                  result.push( href.match(/^(http|https)/)
                                                                      ? href
                                                                      : parts[1]+'://'+parts[2]+(href[0]=='/'? href: '/'+href)
                                                                    )
                                              }
                                              return result
                                            }, [ ])
                            })
        console.log("*** after meta")
        var images = Array.apply([ ], SH.getElementsByTagName('img'))
        console.log("*** images len = " + images.length)
        var metaImages = Array.apply([ ], metaPtr).reduce( (r, it) => {
          let a = it.getAttribute('property'), b = it.getAttribute('name')
            , A = it.getAttribute('content'), B = it.getAttribute('value')
            , types = [ 'og:image', 'twitter:image', 'twitter:image:src' ]
          if( types.indexOf(a) !== -1 || types.indexOf(b) !== -1 )
            r.push(A? A: B)
          return r
        }, [ ])
        console.log("*** metaImages len = " + metaImages.length)
        var allImgList = metaImages.concat(images.reduce((r,it) => {
            var altSrc = it.getAttribute('data-src-medium'); // cnn
            if (altSrc)
              r.push(altSrc);
            else
              r.push(it.src);
            return r;
          }, [ ]))
        console.log("*** allImgList len = " + allImgList.length)
        var imgListWithoutB64 = allImgList.slice(0).filter( url => url.substr(0,10) != 'data:image')
        console.log("*** allImgList without b64 len = " + imgListWithoutB64.length)
        var imgList = allImgList.slice(0)
          .map( url => { 
            // it.match(/^(http|https)/)? it: parts[1]+'://'+parts[2]+(it[0]=='/'? it: '/'+it) 
            if (url.substr(0,2) == '//')
              return (isHTTPS ? 'https:' : 'http:') + url
            else
              return url.match(/^(http|https)/) ? url : parts[1]+'://'+parts[2]+(url[0]=='/'? url: '/'+url)
          } )
          .filter( it => it.match(/(jpe?g|png)$/) )
        console.log("*** imgList len = " + imgList.length)
        console.log("urlReference = " + JSON.stringify(urlReference))
        var message = { callingArgs, urlReference, meta, metaImages, parts, images : imgListWithoutB64.concat(styleImages()), styleImages: styleImages(), bgImages: getElementBackgroundImages(), numImgTags: document.getElementsByTagName('img').length, numDivs: document.getElementsByTagName('div').length }
        console.log("**** ready to return message " + JSON.stringify(message));
        return message
    } catch ( err ) {
      // this is internal web view console not seen in xcode need to hook up safari to see it
      console.log("**** err = " + JSON.stringify(err));
      if (window.ReactNativeWebView.postMessage) window.ReactNativeWebView.postMessage(JSON.stringify({ meta : false, error: JSON.stringify(err), errorMessage: err.message }))
      else console.log("ReactNativeWebView.postMessage fn does not exist in catch")
    }
    return null;
	}
  
  function periodicCheck() {
    scanTries = scanTries + 1;
    if (scanTries > 12)
      return
    var startTime = Date.now();
    var message = scanForImagesInner();
    var elapsed = Date.now() - startTime;
    if (message && (message.images > 0 || message.numDivs > 0)) {
      message.scanTime = elapsed;
      message.scanTries = scanTries;
      message.videoCount = videoCount;
      if(window.RNText) message.url = window.RNText
      if (window.ReactNativeWebView.postMessage) window.ReactNativeWebView.postMessage(JSON.stringify(message))
      else console.log("ReactNativeWebView.postMessage fn does not exist location 1")
    }
    setTimeout(periodicCheck, 1000) // 5000
  }
  
  docReady(function() { setTimeout(periodicCheck, 500) }); // 2000
}

function siteMetaFetch() {
  var callingArgs = arguments;
  try {
    var SH = document
      , text = window.RNPayload? String(window.RNPayload.map(function(code){return String.fromCodePoint(code)}).join('')): false
      , parts = (window.RNUrl? window.RNUrl: window.location.href).match(/(http|https):\/\/([^\/]+)(.*)/)
      , isHTTPS = ('' + window.RNUrl).substr(0,6).toLowerCase() == 'https:'
    if(text) {
      SH = document.createElement('html')
      SH.innerHTML = text
    }
    var props = { title : [ 'og:title', 'twitter:title' ]
                , description : [ 'og:description' ]
                , image : [ 'og:image', 'twitter:image', 'twitter:image:src' ]
                , alt : [ 'twitter:image:alt' ]
                , 'site_name' : [ 'og:site_name' ]
                , site : [ 'twitter:site' ]
                , type : [ 'og:type' ]
                }
      , metaPtr = SH.getElementsByTagName('meta')
      , meta = Array.apply( [ ], metaPtr )
                          .reduce(function(result,iter) {
                            function g(a,b) { return iter.getAttribute(a) || iter.getAttribute(b) }
                            var key = g('property', 'name'), value = g('content', 'value')
                            if(!key||!value||!key.length||!value.length) return result
                            for( var k in props )
                              for( var j = 0 ; j < props[k].length; ++ j )
                                if( key === props[k][j] || key === k ) { result[k] = value ; break }
                            return result
                          }
                          , { favicons : Array.apply( [ ], SH.getElementsByTagName('link') )
                                          .reduce(function( result, iter ) {
                                            var rel = iter.getAttribute('rel')
                                            if( ! rel || ! rel.match(/icon/) ) return result
                                            var href = iter.getAttribute('href')
                                            // no relative links allowed
                                            if( href ) {
                                              if (href.length > 4 && href.substr(-4) == '.ico')
                                                return result
                                              if (href.substr(0,2) == '//')
                                                result.push((isHTTPS ? 'https:' : 'http:') + href)
                                              else
                                                result.push( href.match(/^(http|https)/)
                                                              ? href
                                                              : parts[1]+'://'+parts[2]+(href[0]=='/'? href: '/'+href)
                                                            )
                                            }
                                            return result
                                          }, [ ])
                          })
      , images = Array.apply([ ], SH.getElementsByTagName('img'))
      , metaImages = Array.apply([ ], metaPtr).reduce( (r, it) => {
        let a = it.getAttribute('property'), b = it.getAttribute('name')
          , A = it.getAttribute('content'), B = it.getAttribute('value')
          , types = [ 'og:image', 'twitter:image', 'twitter:image:src' ]
        if( types.indexOf(a) !== -1 || types.indexOf(b) !== -1 )
          r.push(A? A: B)
        return r
      }, [ ])
      , allImgList = metaImages.concat(images.reduce((r,it) => { r.push(it.src); return r }, [ ]))
      , imgListWithoutB64 = allImgList.slice(0).filter( url => url.substr(0,10) != 'data:image')
      , imgList = allImgList.slice(0)
        .map( url => { 
          // it.match(/^(http|https)/)? it: parts[1]+'://'+parts[2]+(it[0]=='/'? it: '/'+it) 
          if (url.substr(0,2) == '//')
            return (isHTTPS ? 'https:' : 'http:') + url
          else
            return url.match(/^(http|https)/) ? url : parts[1]+'://'+parts[2]+(url[0]=='/'? url: '/'+url)
        } )
        .filter( it => it.match(/(jpe?g|png)$/) )

    if (!meta.title)
        meta.title = document.title
    var message = { callingArgs, meta, images : imgListWithoutB64 }
    if(window.RNText) message.url = window.RNText
    if (window.ReactNativeWebView.postMessage) window.ReactNativeWebView.postMessage(JSON.stringify(message))
    else console.log("ReactNativeWebView.postMessage fn does not exist location 1")
  } catch ( err ) {
    // this is internal web view console not seen in xcode need to hook up safari to see it
    console.log("err = " + JSON.stringify(err))
    if (window.ReactNativeWebView.postMessage) window.ReactNativeWebView.postMessage(JSON.stringify({ meta : false }))
    else console.log("ReactNativeWebView.postMessage fn does not exist in catch")
  }
}
